var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout-blank scrollable"},[_vm._v("\n\tBlank page\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }